<template>
  <div>
    <b-sidebar
      id="sidebar-Fee"
      bg-variant="white"
      v-model="visibility1"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Manage Category</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility1 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col cols="12" md="12">
            <b-form-group
              ref="icon"
              label="Icon"
              invalid-feedback="Icon is required."
            >
              <div class="lib-photo-upload">
                <div
                  v-if="!categoryIconPreview && logoloading !== true"
                  class="lib-photo-upload__slot"
                >
                  <b-img
                    ref="previewEl"
                    src="https://placehold.co/140x140?text=Icon"
                    @click="$refs.fileProfile.click()"
                    style="border-radius: 10px"
                    height="140px"
                    width="140px"
                  />
                </div>

                <div
                  v-else-if="!categoryIconPreview && logoloading === true"
                  class="lib-photo-upload__slot"
                >
                  <b-spinner
                    variant="primary"
                    type="grow"
                    label="Spinning"
                  />
                </div>

                <div v-else class="lib-photo-upload__preview">
                  <img
                    :src="categoryIconPreview"
                    height="140"
                    width="140"
                    class="lib-photo-upload__img"
                    referrerpolicy="no-referrer"
                    alt="Category icon"
                    @click="logoloading !== true && $refs.fileProfile.click()"
                    @error="onCategoryIconError"
                  />
                  <div
                    v-if="logoloading === true"
                    class="lib-photo-upload__overlay"
                    style="border-radius: 10px"
                  >
                    <b-spinner variant="primary" type="grow" />
                  </div>
                  <b-button
                    v-if="logoloading !== true"
                    @click="deleteLogo()"
                    class="btn-icon lib-photo-upload__delete"
                    variant="danger"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </div>
              </div>
              <input
                type="file"
                id="fileProfile"
                hidden
                ref="fileProfile"
                @change="selectlogo()"
                accept="image/*"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Category"
              invalid-feedback="Category is required."
              ref="CatName"
            >
              <b-form-input
                placeholder="Enter category name"
                v-model.trim="catObj.category"
                @focusout="CheckCatName()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              type="submit"
              variant="success"
              @click="AddCategory()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-Fee"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Manage Publisher</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>

      <b-form class="p-2" @submit.prevent>
        <b-row class="d-flex align-items-center">
          <b-col md="10">
            <b-form-group
              label="Publisher"
              invalid-feedback="Publisher is required."
            >
              <b-form-input
                ref="publisher"
                v-model.trim="pubObj.publisher"
                placeholder="Enter publisher name"
                @focusout="CheckPub()"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-button
              variant="success"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="savePub()"
              :disabled="request"
            >
              <b-spinner v-if="request" small type="grow" />
              <feather-icon v-else :icon="buttonIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-table
          class="mt-1"
          show-empty
          :items="publishers"
          :fields="pubFields"
          responsive
          hover
        >
          <template #head(actions)="data">
            <div class="text-right">
              <span>{{ data.label }}</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="text-right">
              <b-button
                variant="primary"
                class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                @click="editPub(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                variant="outline-danger"
                class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                @click="deletePub(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-Fee"
      bg-variant="white"
      v-model="visibility3"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Manage Author</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility3 = false"
        />
      </div>

      <b-form class="p-2" @submit.prevent>
        <b-row class="d-flex align-items-center">
          <b-col md="10">
            <b-form-group label="Author" invalid-feedback="Author is required.">
              <b-form-input
                ref="author"
                v-model.trim="authObj.author"
                placeholder="Enter author name"
                @focusout="CheckAuth()"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-button
              variant="success"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="saveAuth()"
              :disabled="request"
            >
              <b-spinner v-if="request" small type="grow" />
              <feather-icon v-else :icon="buttonIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-table
          class="mt-1"
          show-empty
          :items="authors"
          :fields="authFields"
          responsive
          hover
        >
          <template #head(actions)="data">
            <div class="text-right">
              <span>{{ data.label }}</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="text-right">
              <b-button
                variant="primary"
                class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                @click="editAuth(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                variant="outline-danger"
                class="btn-icon mr-0 ml-sm-1 mb-1 mb-sm-0"
                @click="deleteAuth(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-form>
    </b-sidebar>

    <b-card v-if="showForm">
      <h3>Add Book</h3>
      <hr />
      <b-row class="lib-form align-items-center">
        <div class="p-1 lib-form-left">
          <b-form-group
            ref="cover"
            label="Book Cover"
            invalid-feedback="Book Cover is required."
          >
            <div class="lib-photo-upload">
              <div
                v-if="!bookCoverPreview && coverLoading !== true"
                class="lib-photo-upload__slot"
              >
                <b-img
                  ref="previewEl"
                  src="https://placehold.co/160x180?text=Book+Cover"
                  @click="$refs.coverImg.click()"
                  style="border-radius: 10%"
                  height="180px"
                  width="160px"
                />
              </div>

              <div
                v-else-if="!bookCoverPreview && coverLoading === true"
                class="lib-photo-upload__slot"
              >
                <b-spinner variant="primary" type="grow" label="Spinning" />
              </div>

              <div v-else class="lib-photo-upload__preview">
                <img
                  :src="bookCoverPreview"
                  height="180"
                  width="160"
                  class="lib-photo-upload__img lib-photo-upload__img--cover"
                  referrerpolicy="no-referrer"
                  alt="Book cover"
                  @click="coverLoading !== true && $refs.coverImg.click()"
                  @error="onBookCoverError"
                />
                <div
                  v-if="coverLoading === true"
                  class="lib-photo-upload__overlay lib-photo-upload__overlay--cover"
                >
                  <b-spinner variant="primary" type="grow" />
                </div>
                <b-button
                  v-if="coverLoading !== true"
                  @click="deleteCover()"
                  class="btn-icon lib-photo-upload__delete"
                  variant="danger"
                >
                  <feather-icon icon="Trash2Icon" size="18" />
                </b-button>
              </div>
            </div>
            <input
              type="file"
              id="coverImg"
              hidden
              ref="coverImg"
              @change="selectCover()"
              accept="image/*"
            />
          </b-form-group>
        </div>
        <div class="p-1 lib-form-right">
          <b-col xl="3" lg="3" md="4">
            <b-form-group
              label="Book Title"
              invalid-feedback="Book title is required."
              ref="title"
            >
              <b-form-input
                placeholder="Enter book title"
                v-model.trim="myObj.title"
                @focusout="CheckTitle()"
              />
            </b-form-group>
          </b-col>

          <b-col xl="3" lg="3" md="4">
            <b-form-group invalid-feedback="Category is required." ref="catId">
              <div class="d-flex justify-content-between pb-50">
                <label class="bv-no-focus-ring col-form-label p-0"
                  >Category</label
                >
                <feather-icon
                  icon="Edit2Icon"
                  class="cursor-pointer"
                  v-b-tooltip.hover.top
                  title="Manage Category"
                  @click="AddOpen()"
                />
              </div>
              <v-select
                ref="catId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="items"
                :reduce="(opt) => opt.id"
                :clearable="false"
                label="category"
                v-model="myObj.categoryID"
                placeholder="Select Category"
                @change="CheckCatId()"
              />
            </b-form-group>
          </b-col>

          <b-col xl="3" lg="3" md="4">
            <b-form-group invalid-feedback="Publisher is required." ref="pubId">
              <div class="d-flex justify-content-between pb-50">
                <label class="bv-no-focus-ring col-form-label p-0"
                  >Publisher</label
                >
                <feather-icon
                  icon="Edit2Icon"
                  class="cursor-pointer"
                  v-b-tooltip.hover.top
                  title="Manage Publisher"
                  @click="openPub()"
                />
              </div>
              <v-select
                ref="pubId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="publishers"
                :reduce="(opt) => opt.id"
                :clearable="false"
                label="publisher"
                v-model="myObj.publisherID"
                placeholder="Select publisher"
                @change="CheckPubId()"
              />
            </b-form-group>
          </b-col>

          <b-col xl="3" lg="3" md="4">
            <b-form-group invalid-feedback="Author is required." ref="authId">
              <div class="d-flex justify-content-between pb-50">
                <label class="bv-no-focus-ring col-form-label p-0"
                  >Author</label
                >
                <feather-icon
                  icon="Edit2Icon"
                  class="cursor-pointer"
                  v-b-tooltip.hover.top
                  title="Manage Author"
                  @click="openAuth()"
                />
              </div>
              <v-select
                ref="authId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="authors"
                :reduce="(opt) => opt.id"
                :clearable="false"
                label="author"
                v-model="myObj.authorID"
                placeholder="Select Author"
                @change="CheckAuthId()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              label="Book details"
              invalid-feedback="Book Details is required"
              ref="desc"
            >
              <b-form-input
                placeholder="Enter book details"
                v-model.trim="myObj.details"
                @focusout="CheckDesc()"
              />
            </b-form-group>
          </b-col>

          <b-col xl="3" lg="3" md="4">
            <b-form-group
              label="PDF"
              invalid-feedback="PDF is required."
              ref="bookPdf"
            >
              <b-button
                variant="primary"
                :disabled="uploading"
                @click="$refs.pdf.click()"
                v-if="!mediaLoaded"
                block
              >
                <b-spinner
                  v-if="uploading"
                  small
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <div v-else>
                  <input
                    type="file"
                    id="pdf"
                    hidden
                    ref="pdf"
                    @change="uploadPdf()"
                    accept="application/pdf"
                  />
                  <span class="align-middle">Upload</span>
                </div>
              </b-button>
              <div v-else class="">
                <b-button variant="primary">
                  <a :href="myObj.pdf" target="_blank" class="text-light">
                    <feather-icon icon="BookIcon" size="20" />
                  </a>
                </b-button>
                <feather-icon
                  icon="Trash2Icon"
                  class="text-danger ml-1 cursor-pointer"
                  size="20"
                  @click="removePdf()"
                />
              </div>
            </b-form-group>
          </b-col>
        </div>
      </b-row>
      <b-row align-h="end">
        <b-col md="2">
          <b-button
            class="mb-50"
            variant="outline-secondary"
            @click="showForm = false"
            block
          >
            <span>Close</span>
          </b-button>
        </b-col>
        <b-col md="2">
          <b-button
            class="mb-50"
            variant="success"
            @click="Add()"
            :disabled="request"
            block
          >
            <b-spinner v-if="request" small type="grow" />
            <span v-else> Save </span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-else>
      <b-row align-h="end" class="text-right">
        <b-col class="mt-xl-0 mt-lg-0 mt-md-0 mt-sm-1 mt-1" cols="11">
          <b-dropdown
            class="mx-25 mb-25"
            v-for="(d, ind) in items"
            :key="ind"
            split
            :variant="current == d.id ? 'primary' : 'outline-primary'"
            :text="d.category"
            right
          >
            <!-- @click="LoadGrid(d.id)" -->
            <b-dropdown-item v-if="rights.edit" @click="EditCat(d)">
              Edit
            </b-dropdown-item>
            <b-dropdown-item v-if="rights.delete" @click="DeleteCat(d.id)">
              Delete
            </b-dropdown-item>

            <b-dropdown-divider />
          </b-dropdown>
        </b-col>
        <b-col
          class="mt-xl-0 mt-lg-0 mt-md-0 mt-sm-1 mt-1 mr-50"
          cols="*"
          v-if="rights.add"
        >
          <b-button
            @click="AddOpen()"
            variant="primary"
            class="btn-icon rounded-circle mr-50"
          >
            <feather-icon size="16" icon="PlusIcon" />
          </b-button>

          <!-- <b-button
            @click="showAll = !showAll"
            variant="outline-primary"
            class="btn-icon rounded-circle"
          >
            <feather-icon
              v-if="!showAll"
              class="cursor-pointer"
              size="20"
              icon="ArrowDownIcon"
            />
            <feather-icon
              v-else
              class="cursor-pointer"
              icon="ArrowUpIcon"
              size="20"
            />
          </b-button> -->
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col xl="2" lg="3" md="4" sm="12" cols="12" v-if="rights.add">
          <b-button @click="openBook()" variant="primary" block>
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">Add Book</span>
          </b-button>
        </b-col>

        <b-col
          class="mt-lg-0 mt-md-0 mt-sm-1 mt-1"
          xl="10"
          lg="9"
          md="8"
          sm="12"
          cols="12"
        >
          <b-form-group class="">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model.trim="searchQuery"
                :placeholder="$t('Search') + '...'"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        :busy="dataLoading"
        :current-page="currentPage"
        :per-page="perPage"
        show-empty
        responsive
        hover
      >
        <!-- selectable
        select-mode="single"
        @row-selected="EditBook($event[0])" -->
        <template #empty="scope">
          <h3 class="mt-1 mb-1 text-center">{{ $t("No records found") }}</h3>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>
        <template #cell(cover)="data">
          <img
            v-if="data.item.cover"
            :src="getCoverPreviewUrl(data.item.cover)"
            height="100"
            width="100"
            style="border-radius: 0.357rem; object-fit: cover"
            referrerpolicy="no-referrer"
            alt="cover"
            @error="onGridCoverError($event, data.item.cover)"
          />
          <b-img
            v-else
            src="https://placehold.co/100x100?text=No+Cover"
            rounded
            height="100px"
            width="100px"
            alt="cover"
          />
        </template>

        <template #cell(title)="data">
          <b-badge variant="light-primary">
            {{ data.item.title }}
          </b-badge>
        </template>

        <template #head(actions)="data">
          <div class="mr-5 text-center">
            <span>{{ data.label }}</span>
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="text-center">
            <b-button
              v-if="rights.edit"
              variant="primary"
              v-b-tooltip.hover.top
              title="Edit"
              class="btn-icon mr-1"
              @click="EditBook(data.item)"
            >
              <feather-icon icon="EditIcon" class="" />
            </b-button>
            <b-button
              v-if="rights.delete"
              variant="outline-danger"
              v-b-tooltip.hover.top
              title="Delete"
              class="btn-icon"
              @click="DeleteBook(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" class="" />
            </b-button>
          </div>
        </template>
      </b-table>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="filters.length"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BModal,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapActions, mapGetters } from "vuex";
import {
  getUploadPath,
  uploadToMySkool,
  getMediaPreviewUrl,
  handleDrivePreviewError,
} from "@/utils/gdriveUpload";

export default {
  components: {
    BModal,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BMediaAside,
    BImg,
    BMedia,
    BLink,
    BForm,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
  },
  async created() {
    // let right = {};
    // this.$store.state.menu.forEach((el) => {
    //   el.children.forEach((ch) => {
    //     right[ch.route] = {
    //       view: ch.view,
    //       add: ch.add,
    //       edit: ch.edit,
    //       delete: ch.delete,
    //     };
    //   });
    // });
    // // console.log(right);
    // this.$store.commit("setRights", right);

    // if (!this.$store.state.rights[this.$route.name]) {
    //   // console.log(this.$store.state.rights[this.$route.name]);
    //   this.$router.replace({
    //     name: "misc-not-authorized",
    //   });
    // } else {
    //   this.rights = this.$store.state.rights[this.$route.name];
    //   this.LoadGrid();
    //   this.LoadData(0);
    //   this.LoadPub();
    //   this.LoadAuth();
    // }

    this.LoadGrid();
    this.LoadData(0);
    this.LoadPub();
    this.LoadAuth();
  },
  computed: {
    filters: function () {
      return this.gridData.filter((pro) => {
        return pro.title.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
    categoryIconPreview() {
      const src = this.iconPreview || this.catObj.icon || "";
      if (!src) return "";
      if (String(src).startsWith("blob:")) return src;
      return getMediaPreviewUrl(src, "Image");
    },
    bookCoverPreview() {
      const src = this.coverPreview || this.myObj.cover || "";
      if (!src) return "";
      if (String(src).startsWith("blob:")) return src;
      return getMediaPreviewUrl(src, "Image");
    },
  },
  data() {
    return {
      rights: {
        view: true,
        add: true,
        edit: true,
        delete: true,
      },
      showAll: false,
      myDepartments: [],
      request: false,
      colorDep: [],
      visibility1: false,
      visibility2: false,
      visibility3: false,
      buttonIcon: "PlusIcon",
      dataLoading: false,
      coverLoading: false,
      iconPreview: "",
      coverPreview: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      index: null,
      fields: [
        { label: "cover", key: "cover" },
        { label: "title", key: "title" },
        { label: "details", key: "details" },
        { key: "actions", label: "actions" },
      ],
      pubFields: [
        { label: "Publisher", key: "publisher" },
        { key: "actions", label: "actions" },
      ],
      authFields: [
        { label: "Author", key: "author" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      gridData: [],
      selected: null,
      rangeDate: null,
      myObj: {
        id: 0,
        categoryID: 0,
        authorID: 0,
        authorID: 0,
        publisherID: 0,
        title: "",
        details: "",
        cover: "",
        pdf: "",
        status: "active",
        tag: "",
        campusID: this.$store.state.userData.cId,
      },
      assignedClass: null,
      classes: [],
      publishers: [],
      authors: [],
      showForm: false,
      catObj: {
        id: 0,
        category: "",
        icon: "",
        status: "",
        sequence: 0,
        campusID: this.$store.state.userData.cId,
      },
      logoloading: false,
      pubObj: {
        id: 0,
        publisher: "",
        sequence: 0,
        campusID: this.$store.state.userData.cId,
      },
      pubObj: {
        id: 0,
        publisher: "",
        sequence: 0,
        campusID: this.$store.state.userData.cId,
      },
      authObj: {
        id: 0,
        publisher: "",
        sequence: 0,
        campusID: this.$store.state.userData.cId,
      },
      current: 0,
      mediaLoaded: false,
      uploading: false,
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    getCoverPreviewUrl(url) {
      if (!url) return "";
      return getMediaPreviewUrl(url, "Image");
    },

    onCategoryIconError(event) {
      const url = this.iconPreview || this.catObj.icon;
      if (!url || String(url).startsWith("blob:")) return;
      handleDrivePreviewError(event, url, "image");
    },

    onBookCoverError(event) {
      const url = this.coverPreview || this.myObj.cover;
      if (!url || String(url).startsWith("blob:")) return;
      handleDrivePreviewError(event, url, "image");
    },

    onGridCoverError(event, url) {
      if (!url) return;
      handleDrivePreviewError(event, url, "image");
    },

    clearIconPreview() {
      if (this.iconPreview && String(this.iconPreview).startsWith("blob:")) {
        URL.revokeObjectURL(this.iconPreview);
      }
      this.iconPreview = "";
    },

    clearCoverPreview() {
      if (this.coverPreview && String(this.coverPreview).startsWith("blob:")) {
        URL.revokeObjectURL(this.coverPreview);
      }
      this.coverPreview = "";
    },

    openBook() {
      this.myObj = {
        id: 0,
        categoryID: 0,
        authorID: 0,
        authorID: 0,
        publisherID: 0,
        title: "",
        details: "",
        cover: "",
        pdf: "",
        status: "active",
        tag: "",
        campusID: this.$store.state.userData.cId,
      };
      this.showForm = true;
      this.mediaLoaded = false;
      this.coverLoading = false;
      this.clearCoverPreview();
    },
    EditBook(item) {
      this.clearCoverPreview();
      this.myObj = { ...item };
      this.showForm = true;
      if (!this.myObj.cover) {
        this.coverLoading = false;
      } else this.coverLoading = "loaded";
      if (!this.myObj.pdf) {
        this.mediaLoaded = false;
      } else this.mediaLoaded = true;
    },
    removePdf() {
      this.myObj.pdf = null;
      this.mediaLoaded = false;
      this.$refs.pdf.value = null;
    },
    async uploadPdf() {
      if (this.$refs.pdf.files[0]) {
        this.uploading = true;
        this.mediaLoaded = false;
        try {
          const uploaded = await uploadToMySkool([this.$refs.pdf.files[0]]);
          this.myObj.pdf = getUploadPath(uploaded[0]);
          this.mediaLoaded = true;
          this.CheckPdf();
        } catch (err) {
          console.log(err);
        } finally {
          this.uploading = false;
        }
      }
    },
    deleteCover() {
      this.clearCoverPreview();
      this.myObj.cover = null;
      this.coverLoading = false;
      if (this.$refs.coverImg) this.$refs.coverImg.value = "";
    },
    async selectCover() {
      const file = this.$refs.coverImg.files[0];
      if (!file) return;

      this.clearCoverPreview();
      this.coverLoading = true;
      const localPreview = URL.createObjectURL(file);
      this.coverPreview = localPreview;

      try {
        const uploaded = await uploadToMySkool([file]);
        const path = getUploadPath(uploaded[0]);
        if (!path) throw new Error("Upload path missing");

        URL.revokeObjectURL(localPreview);
        this.coverPreview = "";
        this.myObj.cover = path;
        this.coverLoading = "loaded";
      } catch (err) {
        URL.revokeObjectURL(localPreview);
        this.coverPreview = "";
        this.myObj.cover = null;
        this.coverLoading = false;
        console.log(err);
      } finally {
        if (this.$refs.coverImg) this.$refs.coverImg.value = "";
      }
    },
    async DeleteBook(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "Books/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Book removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadGrid();
      }
    },

    async LoadPub() {
      var obj = {
        url:
          this.$store.state.domain +
          "BooksPublisher?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.publishers = await this.get(obj);
      // console.log("pub", this.publishers);
    },
    openPub() {
      this.pubObj = {
        id: 0,
        publisher: "",
        sequence: 0,
        campusID: this.$store.state.userData.cId,
      };

      this.visibility2 = true;
      this.buttonIcon = "PlusIcon";

      var elem = this.$refs["publisher"];
      elem.state = undefined;
    },
    editPub(item) {
      this.pubObj = { ...item };
      this.buttonIcon = "Edit2Icon";
      // console.log(this.pubObj);
    },
    CheckPub() {
      var elem = this.$refs["publisher"];
      if (!this.pubObj.publisher) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async savePub() {
      this.CheckPub();
      if (this.CheckPub() == true) {
        if (this.pubObj.id == 0) {
          //Add
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "BooksPublisher?db=" +
              this.$store.state.userData.db,
            body: this.pubObj,
            message: "Book Publisher added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.LoadPub();
            this.pubObj = {
              id: 0,
              publisher: "",
              sequence: 0,
              campusID: this.$store.state.userData.cId,
            };
            var elem = this.$refs["publisher"];
            elem.state = undefined;
          }
        } else {
          //Edit
          this.request = true;
          var status = await this.put({
            url:
              this.$store.state.domain +
              "BooksPublisher/" +
              this.pubObj.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.pubObj,
            message: "Book Publisher updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.LoadPub();
            this.pubObj = {
              id: 0,
              publisher: "",
              sequence: 0,
              campusID: this.$store.state.userData.cId,
            };
            var elem = this.$refs["publisher"];
            elem.state = undefined;
          }
        }
      }
    },
    async deletePub(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "BooksPublisher/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Book Publisher removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadPub();
      }
    },

    async LoadAuth() {
      var obj = {
        url:
          this.$store.state.domain +
          "BooksAuthor?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.authors = await this.get(obj);
      // console.log("aut", this.authors);
    },
    openAuth() {
      this.authObj = {
        id: 0,
        author: "",
        sequence: 0,
        campusID: this.$store.state.userData.cId,
      };

      this.visibility3 = true;
      this.buttonIcon = "PlusIcon";

      var elem = this.$refs["author"];
      elem.state = undefined;
      this.buttonIcon = "PlusIcon";
    },
    editAuth(item) {
      this.authObj = { ...item };
      this.buttonIcon = "Edit2Icon";
      // console.log(this.authObj);
    },
    CheckAuth() {
      var elem = this.$refs["author"];
      if (!this.authObj.author) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async deleteAuth(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "BooksAuthor/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Book Author removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadAuth();
      }
    },
    async saveAuth() {
      this.CheckAuth();
      if (this.CheckAuth() == true) {
        if (this.authObj.id == 0) {
          //Add
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "BooksAuthor?db=" +
              this.$store.state.userData.db,
            body: this.authObj,
            message: "Book Author added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.LoadAuth();
            this.authObj = {
              id: 0,
              author: "",
              sequence: 0,
              campusID: this.$store.state.userData.cId,
            };
            var elem = this.$refs["author"];
            elem.state = undefined;
          }
        } else {
          //Edit
          this.request = true;
          var status = await this.put({
            url:
              this.$store.state.domain +
              "BooksAuthor/" +
              this.authObj.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.authObj,
            message: "Book Author updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.LoadAuth();
            this.authObj = {
              id: 0,
              author: "",
              sequence: 0,
              campusID: this.$store.state.userData.cId,
            };
            var elem = this.$refs["author"];
            elem.state = undefined;
          }
        }
      }
    },

    async LoadData(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "BooksCategries?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);
    },
    AddOpen() {
      this.clearIconPreview();
      this.catObj = {
        id: 0,
        category: "",
        icon: "",
        status: "active",
        sequence: 0,
        campusID: this.$store.state.userData.cId,
      };
      this.visibility1 = true;
      this.logoloading = false;
      var elem = this.$refs["CatName"];
      elem.state = undefined;
      var elem = this.$refs["icon"];
      elem.state = undefined;
    },
    async selectlogo() {
      const file = this.$refs.fileProfile.files[0];
      if (!file) return;

      this.clearIconPreview();
      this.logoloading = true;
      const localPreview = URL.createObjectURL(file);
      this.iconPreview = localPreview;

      try {
        const uploaded = await uploadToMySkool([file]);
        const path = getUploadPath(uploaded[0]);
        if (!path) throw new Error("Upload path missing");

        URL.revokeObjectURL(localPreview);
        this.iconPreview = "";
        this.catObj.icon = path;
        this.logoloading = "loaded";
      } catch (err) {
        URL.revokeObjectURL(localPreview);
        this.iconPreview = "";
        this.catObj.icon = "";
        this.logoloading = false;
        console.log(err);
      } finally {
        if (this.$refs.fileProfile) this.$refs.fileProfile.value = "";
      }
    },
    deleteLogo() {
      this.clearIconPreview();
      this.catObj.icon = null;
      this.logoloading = false;
      if (this.$refs.fileProfile) this.$refs.fileProfile.value = "";
    },
    EditCat(item) {
      this.clearIconPreview();
      this.catObj = { ...item };
      this.visibility1 = true;
      if (this.catObj.icon) {
        this.logoloading = "loaded";
      } else this.logoloading = false;

      var elem = this.$refs["CatName"];
      elem.state = undefined;
      var elem = this.$refs["icon"];
      elem.state = undefined;
    },
    CheckCatName() {
      var elem = this.$refs["CatName"];
      if (!this.catObj.category) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckIcon() {
      var elem = this.$refs["icon"];
      // console.log(elem);
      if (!this.catObj.icon) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async AddCategory() {
      let s1 = this.CheckCatName();
      // this.CheckIcon();
      if (s1) {
        if (this.catObj.id == 0) {
          //Add
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "BooksCategries?db=" +
              this.$store.state.userData.db,
            body: this.catObj,
            message: "Book Category added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility1 = false;
          if (status) this.LoadData(1);
        } else {
          //Edit
          this.request = true;
          var status = await this.put({
            url:
              this.$store.state.domain +
              "BooksCategries/" +
              this.catObj.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.catObj,
            message: "Book Categries updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility1 = false;
          if (status) this.LoadData(this.catObj.id);
        }
      }
    },
    async DeleteCat(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "BooksCategries/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Category removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData(0);
      }
    },

    CheckTitle() {
      var elem = this.$refs["title"];
      if (!this.myObj.title) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckPdf() {
      var elem = this.$refs["bookPdf"];
      if (!this.myObj.pdf) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDesc() {
      var elem = this.$refs["desc"];
      if (!this.myObj.details) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckCatId() {
      var elem = this.$refs["catId"];
      if (this.myObj.categoryID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckPubId() {
      var elem = this.$refs["pubId"];
      if (this.myObj.publisherID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckAuthId() {
      var elem = this.$refs["authId"];
      if (this.myObj.authorID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async Add() {
      // console.log("obj:", this.myObj);
      this.CheckTitle();
      this.CheckPdf();
      // this.CheckDesc();
      this.CheckCatId();
      this.CheckAuthId();
      this.CheckPubId();
      if (
        this.CheckTitle() == false ||
        // this.CheckDesc() == false ||
        this.CheckPdf() == false ||
        this.CheckCatId() == false ||
        this.CheckPubId() == false ||
        this.CheckAuthId() == false
      ) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.myObj.id == 0) {
          //Add
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Books?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Book added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.LoadGrid(1);
          }
        } else {
          //Edit
          this.request = true;
          var status = await this.put({
            url:
              this.$store.state.domain +
              "Books/" +
              this.myObj.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Book updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.LoadGrid(this.myObj.id);
          }
        }
      }
    },
    async LoadGrid(id) {
      this.showForm = false;
      // this.current = id;
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Books?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.gridData = await this.get(obj);
      this.dataLoading = false;
      // console.log("grid", this.gridData);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.lib-form-right {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
}

.lib-form-left {
  width: 20%;
}

@media (max-width: 1100px) {
  .lib-form-right {
    width: 75%;
  }
  .lib-form-left {
    width: 25%;
  }
}
@media (max-width: 992px) {
  .lib-form {
    flex-direction: column;
  }
  .lib-form-right {
    width: 100%;
  }
  .lib-form-left {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

.lib-photo-upload {
  display: flex;
  justify-content: center;
  width: 100%;
}

.lib-photo-upload__slot {
  display: flex;
  align-items: center;
  justify-content: center;
}

.lib-photo-upload__preview {
  position: relative;
  display: flex;
  align-items: center;
}

.lib-photo-upload__img {
  object-fit: cover;
  cursor: pointer;
  display: block;
  border-radius: 10px;
}

.lib-photo-upload__img--cover {
  border-radius: 10%;
  border: 4px solid var(--primary);
}

.lib-photo-upload__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  z-index: 2;
}

.lib-photo-upload__overlay--cover {
  border-radius: 10%;
}

.lib-photo-upload__delete {
  margin-left: 0.5rem;
}
</style>
